// assets/buy-now.js
(function() {
  var STOREFRONT_TOKEN = 'd8c668f65b1a85ffad74e82f1aa99193';
  var API_VERSION = '2025-04';
  // SHOP_DOMAIN needs to be injected from Liquid, e.g. via a global variable or data attribute
  var SHOP_DOMAIN = window.__shopDomain || window.Shopify.shop;

  async function buyNow(btn) {
    // Find variant ID from the closest form context
    var form = btn.closest('form');
    var variantEl = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    var quantityEl = form ? form.querySelector('[name="quantity"]') : null;

    var variantId = variantEl ? variantEl.value : null;
    var quantity = parseInt(quantityEl ? quantityEl.value : 1) || 1;

    if (!variantId) {
      alert('Please select a product variant');
      return;
    }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';

    try {
      var response = await fetch('https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: '\
            mutation cartCreate($input: CartInput!) {\
              cartCreate(input: $input) {\
                cart {\
                  id\
                  checkoutUrl\
                }\
                userErrors {\
                  field\
                  message\
                }\
              }\
            }\
          ',
          variables: {
            input: {
              lines: [{
                merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
                quantity: quantity
              }]
            }
          }
        })
      });

      var data = await response.json();
      var cartData = data.data && data.data.cartCreate;

      if (cartData && cartData.cart && cartData.cart.checkoutUrl) {
        window.location.href = cartData.cart.checkoutUrl;
      } else {
        var errors = (cartData && cartData.userErrors) || [];
        var msg = errors.length > 0 ? errors[0].message : 'Unknown error';
        alert('Failed to create checkout: ' + msg);
        btn.disabled = false;
        btn.textContent = originalText;
      }
    } catch (err) {
      console.error('Buy Now error:', err);
      alert('Network error, please try again');
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }

  // Event delegation on document - works for both static and dynamically injected buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.buy-now-btn');
    if (!btn) return;
    e.preventDefault();
    buyNow(btn);
  });
})();